<template>
  <div class="container">
    <Back @goBack="goHome" v-show="showBack"/>
    <alert
      :sameTwo="alertText"
      :cancal="isShow == 2?'取消':tipText"
      :btn="isShow == 2?'重新输入':''"
      :show="show"
      @cancelEvent="closeAlert"
    ></alert>
    <div class="login_box">
      <div class="login_content" v-if="step == 1">
        <div class="title">{{$route.query.type==='reset'?'手机号码验证':'手机验证码登录'}}</div>
        <!-- 输入框 -->
        <!-- placeholder="请输入手机号"  -->
        <div class="inputBox">
          <input
            ref="inputDom"
            type="tel"
            maxlength="13"
            placeholder="请输入手机号"
            v-model="phone"
            autofocus
            class="user_tel"
            :class="{'inputs':phone}"
          >
          <div class="clear_tel cursor" @click="clear_tel" v-show="phone.length"></div>
        </div>
        <div class="regBox">
          <div class="reginput">
            <input
              type="tel"
              maxlength="4"
              v-model="code"
              placeholder="请输入验证码"
              class="user_reg"
              :class="{'inputs':code}"
            >
          </div>
          <div class="clear_tel cursor" @click="clear_code" v-show="code.length"></div>
          <div class="reg cursor"
            :class="{'login_btn_cur':phone.replace(/\s/g, '').length == 11 && countDown == ''}"
            @click="regPhone">
            {{countDown > 0 ? countDown+'s': '获取验证码'}}
          </div>
        </div>
        <div
          class="login_btn"
          :class="{'login_btn_cur':phone.replace(/\s/g, '').length == 11 && code.length === 4}"
          @click="btnClick"
        >{{$route.query.type==='reset'?'下一步':'登录'}}</div>
      </div>
      <pwd v-if="step==2" @setPwd='setPwd' @showSetTip='showSetTip' ref="pwd" />
    </div>
    <div>
      <a
        v-if="!LIMI_ENV"
        class="go_limishuxue cursor"
        href="http://www.limiwangxiao.com"
        target="_blank"
      >狸米网校官方网站：www.limiwangxiao.com</a>
      <icp/>
    </div>
    <pwdAlert v-if="showTip" :tipType='tipType' @clearPwdReset='clearPwdReset' />
    <toast :showText="showText" v-if="showToast" @toastCallBack="toastCallBack"></toast>
  </div>
</template>
<script>
import Back from "@/components/basic/back.vue";
import icp from "@/components/basic/icp.vue";
import alert from "@/components/basic/alert.vue";
import toast from "@/components/basic/toast.vue";
import pwd from '@/components/basic/pwd.vue';
import pwdAlert from './pwdAlert.vue'
import common from "common";
import liSrv from "liSrv";
import utils from "utils";
import getMD5Config from 'MD5'
import { mapState, mapMutations, mapActions } from "vuex";
export default {
  name: "passwordreset",
  data() {
    return {
      phone: "",
      isShow: 0,
      alertText: "请输入号码",
      tipText: "重新输入",
      countDown: 0,
      code: '',
      sureText: "",
      show: false,
      showTip: false,
      tipType: false,
      showToast: false,
      showText: '',
      step: 1,
      showBack: true,
      LIMI_ENV: LIMI_ENV === "electron"
    };
  },
  components: {
    alert,
    toast,
    Back,
    icp,
    pwd,
    pwdAlert
  },
  computed: {
    ...mapState(["COOK"])
  },
  created() {
    this.phone = (LIMI_ENV === "electron"?utils.getNodeStorge("phone"):common.get("phone"))|| "";
  },
  mounted() {},
  methods: {
    //登录http请求
    ...mapMutations(["refreshNet","saveLogin","saveFirstLogin"]),
    ...mapActions(["loginModel", "getCode", "resetPwd", "regCode", "verifyCodeLogin"]),
    exit() {
      this.$root.eventHub.$emit("exitapp");
    },
    async setPwd(pwd) {
      let {res, ok} = await this.resetPwd({
        phonenum: this.phone.replace(/\s/g, ""),
        usertype: 'student',
        password: pwd,
        verifycode: this.code
      })
      if (ok) {
        this.showSetTip(ok)
      }
    },
    showSetTip(flag) {
      this.showTip = true
      this.tipType = flag
    },
    toastCallBack() {
      this.showToast = false;
    },
    //效验手机号
    checkNumber(data) {
      if (data && data.length == 11) {
        return true;
      } else {
        return false;
      }
    },
    //关闭按钮
    closeAlert() {
      this.show = false;
    },
    clearPwdReset() {
      this.showTip = false
      this.tipType = false
      this.$refs.pwd.resetStatus()
    },
    //下一步按钮点击
    btnClick(){
      let phone = this.phone.replace(/\s/g, "");
      common.set("phone", phone);
      let type = this.$route.query.type;
      if (this.checkNumber(phone) && this.code.length === 4) {
        type==='reset'? this.toResetPwd(phone):this.loginIn(phone)
      }
    },
    //验证码登录
    async loginIn(phone){
      let {res,ok} = await this.verifyCodeLogin({
        phonenum:phone,
        usertype:"student",
        type:5,
        verifycode:this.code,
        from: LIMI_ENV === "electron" ? "live_pc_h5" : "live_pc_web"
      });
      if(ok){
        this.saveFirstLogin(res.first_login_check==0?1:0)
        this.$router.replace({
          name: "class",
          params: {
            from: "first"
          }
        });
      }else{
        this.showToast = true
        this.showText = res.desc
      }
    },
    // 获取验证码
    async getPhoneCode() {
      if (this.countDown) return
      this.countDown = 60
      let codeType = this.$route.query.type==='reset'?3:5
      let {res, ok} = await this.getCode({
        phonenum: this.phone.replace(/\s/g, ""),
        type: codeType,
        appid: 120002,
        sign: getMD5Config('limifudao', this.phone.replace(/\s/g, ""),codeType)
      })
      if (!ok) {
        this.countDown = ''
        this.showToast = true
        this.showText = res.desc
        return
      }
      this.showToast = true
      this.showText = '验证码发送成功'
      let id = setInterval(() => {
        if (this.countDown === 0) {
          clearInterval(id)
          this.countDown = ''
          return
        }
        this.countDown = --this.countDown
      }, 1000)
    },
    //校验验证码，重新登录
    async toResetPwd(phone) {
      let {res, ok} = await this.regCode({
        phonenum: phone,
        type: 3,
        verifycode: this.code
      })
      ok && (this.step = 2)
      if (!ok) {
        this.showToast = true
        this.showText = res.desc
      }
    },
    regPhone() {
      if (this.countDown) return
      let phone = this.phone.replace(/\s/g, "");
      if (this.checkNumber(phone)) {
        if (!navigator.onLine) {
          this.refreshNet(false);
          return;
        }
        this.loadingShow = true;
        this.loginModel({phonenum:phone,usertype:'student'})
          .then(({ res, ok }) => {
            if (ok) {
              if (res.status) {
                this.getPhoneCode()
              } else {
                this.isShow = 1;
                this.alertText = "该账号不存在，请重新输入";
                this.show = true;
              }
            }
          })
      }
    },
    clear_tel() {
      this.phone = "";
    },
    clear_code() {
      this.code = "";
    },
    //返回到启动页
    goHome() {
      this.$router.replace({
        path: '/password',
        query: {
          loginType: 2
        }
      });
    }
  },
  watch: {
    //手机号 3 4 4 格式
    phone(newValue, oldValue) {
      let val = newValue.replace(/[^0-9]/g, "");
      val = val.length > 11 ? val.substr(0, 11) : val;
      if (newValue.length >= oldValue.length || newValue.length == 11) {
        if (val.replace(/\s/g, "").length < 3) {
          this.phone = val.replace(/\s/g, "");
        } else if (
          val.replace(/\s/g, "").length >= 3 &&
          val.replace(/\s/g, "").length < 7
        ) {
          this.phone = val.replace(/\s/g, "").replace(/(\d{3})/, "$1 ");
        } else if (val.replace(/\s/g, "").length >= 7) {
          this.phone = val
            .replace(/\s/g, "")
            .replace(/(\d{3})(\d{4})/, "$1 $2 ");
        }
      } else {
        this.phone = this.phone.trim();
      }
    },
    code(newValue, oldValue) {
      let val = newValue.replace(/[^0-9]/g, "");
      this.code = val.trim();
    }
  }
};
</script>
<style lang="less" rel="stylesheet/stylus" scoped>
.login_box {
  width: 100%;
  height: 100%;
  background: #0089ce;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 0;
  display: flex;
  align-items: center;
  justify-content: space-around;
  .login_content {
    width: 500px;
    position: fixed;
    left: 50%;
    top: 45%;
    transform: translate(-50%, -50%);
    .title {
      font-family: PingFang_Medium;
      font-size: 37px;
      color: #ffffff;
      letter-spacing: 0;
      line-height: 37px;
      margin-bottom: 50px;
      margin-top: -40px;
    }
    p {
      opacity: 0.5;
      font-family: PingFang_Regular;
      font-size: 28px;
      color: #ffffff;
      letter-spacing: 0;
      line-height: 28px;
      margin-top: 25px;
    }
    input::-webkit-input-placeholder{
        color: #4dacdc;
        line-height: 30px;
        font-size: 30px;
      }
    .inputBox {
      position: relative;
      input {
        outline: none;
        height: 100%;
        width: 461px;
        font-size: 37px;
        line-height: 37px;
        margin-top: 40px;
        border-bottom: 1px solid rgba(255,255,255,.3);
        color: #ffffff;
        text-align: left;
        padding-bottom: 20px;
      }
      .inputs {
        -webkit-text-fill-color: white;
      }
      .clear_tel {
        position: absolute;
        right: 22px;
        bottom: 29px;
        background: url("/static/img/login/clear.png") no-repeat;
        width: 30px;
        height: 30px;
        background-size: 100%;
        z-index: 2;
        /*animation: .5s clear_tel 1;*/
        animation: 0.5s zoomIn 1;
      }
    }
    .regBox{
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid rgba(255,255,255,.3);
      width: 461px;
      box-sizing: border-box;
      margin: 20px auto 0;
      .reginput{
        position: relative;
        height: 80px;
        input {
          outline: none;
          width: 240px;
          height: 100%;
          font-size: 37px;
          line-height: 37px;
          color: #ffffff;
          text-align: left;
        }
        input::-webkit-input-placeholder{
          color: #4dacdc;
          line-height: 30px;
          font-size: 30px;
        }
        .inputs {
          -webkit-text-fill-color: white;
        }
      }
      .clear_tel {
        background: url("/static/img/login/clear.png") no-repeat;
        width: 30px;
        height: 30px;
        background-size: 100%;
        /*animation: .5s clear_tel 1;*/
        animation: 0.5s zoomIn 1;
      }
    }
    .reg{
      width: 139px;
      height: 46px;
      background: #66b8e1;
      border-radius: 24px;
      line-height: 46px;
      font-size: 22px;
      color: #0089ce;
    }
    .login_btn {
      margin-top: 93px;
      width: 460px;
      height: 73px;
      font-size: 31px;
      line-height: 73px;
      text-align: center;
      color: #0089ce;
      background: #fff;
      opacity: .4;
      border-radius: 5px;
      transition-duration: 0.5s;
      margin-left: 18px;
      border-radius: 66px;
      cursor: default;
    }
    .login_btn_cur {
      color: #007a9c;
      cursor: pointer;
      background: #ffffff;
      opacity: 1;
    }
    .login_btn_cur:hover {
      background: #cce7f5;
      color: #0077B5;
    }
  }
}
.exitapp {
  height: 50px;
  position: fixed;
  bottom: 0;
  width: 100%;
  font-size: 18px;
  color: #003b61;
  span:hover {
    color: #66afc3;
  }
  .gocompany {
    margin-left: 20px;
  }
}
.go_limishuxue {
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  bottom: 84px;
  opacity: 0.3;
  font-size: 18px;
  color: #ffffff;
  line-height: 18px;
  width: 100%;
}
@media screen and (max-height: 668px) {
  .go_limishuxue {
    bottom: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bussiness/passwordreset/passwordreset.vue